export default function Hero() {
  return (
    <section id="hero" className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/60 via-background-50 to-background-50 pointer-events-none"></div>
      <div className="relative w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>视频平台导航 · 在线视频推荐</span>
            </div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              私密视频播放器
              <br className="sm:hidden" />
              <span className="text-primary-500"> — 热门视频平台大全</span>
              <br />
              <span className="text-foreground-600">在线视频网站推荐与导航</span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              私密视频播放器为您一站式整合香蕉视频、红桃视频、91视频、蜜桃视频等热门在线视频平台入口，
              提供全面的视频大全与平台导航服务。无论您是寻找西瓜视频、樱花视频还是糖豆视频等网络视频资源，
              我们都能帮您快速定位优质内容。平台每周更新推荐，确保收录的视频网站保持活跃可用，
              为您省去逐一搜索的烦恼。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>覆盖 30+ 热门平台</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span>每周更新推荐</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span>安全导航保障</span>
              </div>
            </div>
            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览视频平台大全
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-lg font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-300/60"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门排行
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20video%20streaming%20platform%20concept%20with%20floating%20play%20buttons%20and%20vibrant%20warm%20gradients%2C%20dark%20cinematic%20background%20with%20coral%20red%20and%20golden%20amber%20accent%20glows%2C%20sleek%20interface%20elements%2C%20digital%20entertainment%20aesthetic%2C%20geometric%20shapes%20representing%20media%20content%20cards%2C%20soft%20neon-like%20light%20effects%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20professional%20digital%20art&width=800&height=600&seq=hero-main-visual-01&orientation=landscape"
                alt="私密视频播放器 - 热门视频平台大全"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-950/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}